/**
 * 埋点middleware
 */
const isObject = target => Object.prototype.toString.call(target) === '[object Object]';

function createLoggerMiddleware(extraArgument){
    return ({dispatch,getState}) => next => action => {
        try {
            if(isObject(action) && action.extendParams.log){
                //window.clickLog&&clickLog('from='+action.extendParams.log);
            }
            return next(action);
        } catch (error) {
            return next(action);
        }
    }
}

const Logger = createLoggerMiddleware();

export default Logger;